import { CHANGE_APPLICANT_TYPE } from '../constants';
import { resetActRecordData } from '../actRecord/actions';

const changeApplicantTypeMiddleware = ({ dispatch }) => next => action => {
  const { type } = action;

  if (type !== CHANGE_APPLICANT_TYPE) {
    return next(action);
  }

  dispatch(resetActRecordData());

  return next(action);
};

export default changeApplicantTypeMiddleware;
